import { render, staticRenderFns } from "./aracResimOnay.vue?vue&type=template&id=048fb6a7"
import script from "./aracResimOnay.vue?vue&type=script&lang=js"
export * from "./aracResimOnay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports